export const LOT_DETAILS_METRICS: TopHap.InsightMetric[] = [
  'lot_size_acres',
  'slope',
  'elevation'
]
export const LOT_DETAILS_DESCRIPTIONS = [
  [
    ['Smallest', 'Largest', 'Small', 'Large'],
    ['Smaller', 'Larger']
  ],
  [
    ['Flattest', 'Steepest', 'Flatter', 'Steep'],
    ['More flat', 'Steeper']
  ],
  [
    [
      'Lowest Elevation',
      'Highest Elevation',
      'Low Elevation',
      'High Elevation'
    ],
    ['Lower', 'Higher']
  ]
]
export const LOT_DETAILS_TOLERANCE = 10
export const LOT_DETAILS_OTHER_LABELS = ['Lot', 'lots']

export const NEARBY_STATISTICS_METRICS: TopHap.InsightMetric[] = [
  'age',
  'bathrooms',
  'bedrooms',
  'living_area'
]
export const NEARBY_STATISTICS_DESCRIPTIONS = [
  [
    ['Oldest Home', 'Newest Home', 'Older Home', 'Newer Home'],
    ['Older', 'Newer']
  ],
  [
    ['Fewest Bathrooms', 'Most Bathrooms', 'Few Bathrooms', 'Many Bathrooms'],
    ['Fewer bathrooms', 'More bathrooms']
  ],
  [
    ['Fewest Bedrooms', 'Most Bedrooms', 'Few Bedrooms', 'Many Bedrooms'],
    ['Fewer bedrooms', 'More bedrooms']
  ],
  [
    ['Smallest Home', 'Largest Home', 'Small Home', 'Large Home'],
    ['Smaller', 'Larger']
  ]
]

export const NEARBY_STATISTICS_TOLERANCE = 20
export const NEARBY_STATISTICS_OTHER_LABELS = ['', 'homes']
